import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autosubmit"
export default class extends Controller {
  initialize() {
    if (this.element.nodeName !== "FORM")
      throw new Error(`Expected FORM element, ${this.element.nodeName} given`)
  }

  submit(event) {
    this.element.requestSubmit()
  }
}
